import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dashboard",
  "use": "dashboard-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"dashboard\"><path d=\"M0 8.889h7.111V0H0v8.889zM0 16h7.111v-5.333H0V16zm8.889 0H16V7.111H8.889V16zm0-16v5.333H16V0H8.889z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/dashboard.svg
// module id = Nrj4
// module chunks = 39 44